import { useEffect, useState } from 'react';
import {
  ACCOUNT,
  USER_FID_CARD,
  USER_FID_CARD_DETAIL,
} from '../../../constants/routes';
import ScanFooter from '../ScanFooter';
import BackButton from '../../../components/button/BackButton';
import PageLoader from '../../../components/loader/PageLoader';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAxios
 from '../../../axios/useAxios';
import FidelityCardTile from './FidelityCardTile';
import AddFidCardSlider from './AddFidCardSlider';
import { isAppPWA } from '../../../utils/helper-functions';
import { FooterAccount } from '../../../components/footerAccount';
import { FaPlus } from 'react-icons/fa';
import PrimaryButton from '../../../components/button/PrimaryButton';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import VectorTopFidelity from '../../../styles/img/VectorTopFidelity.png';
import pikkoLogo from '../../../styles/img/logo_pikkopay2.svg';
import { getSubscriptionsDisplayDetails } from './add-card/utils/getSubscriptionsDetails';

const UserFidelityCard = () => {
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const user = useSelector((state) => state.user);
  const {store} = useSelector((state) => state.store);
  const [selectedItem, setSelectedItem] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [fidCards, setFidCards] = useState([]);
  const [showAddFidCardSlider, setShowAddFidCardSlider] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [, setNews] = useState([]);

  const getFidCards = async () => {
    setIsLoading(true);
    axiosInstance
      .get(`/user/${user._id}/fidelity-cards`)
      .then((response) => setFidCards(response.data))
      .catch((error) => {
        console.error({ error });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getFidCards();
    const subscriptions = store?.subscriptions || [];
    const storeName = store?.name?.split(' ')[0] || '';
    const subsDetails = getSubscriptionsDisplayDetails(subscriptions, storeName);
    setNews(subsDetails);
  }, []);

  const onClickFidCard = (fidCard) => {
    navigate(USER_FID_CARD_DETAIL, {
      state: {
        fidCard: {
          fidelityCardPhysicalId: fidCard.externalId,
          fidelityCardBddId: fidCard._id,
          fidelityCompanyId: fidCard.companyId,
        },
        companyId: fidCard.companyId
      },
    });
  };
  const onClickAddFidCard = () => {
    setShowAddFidCardSlider(true);
  };
  const isPWA = isAppPWA();



  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '30px',
    dotsClass: 'slick-dots custom-dots',
    customPaging: (i) => (
      <div className="dot-container">
        <div
          className={`dot transition-all duration-300 ease-in-out ${
            i === activeSlide ? 'active' : ''
          }`}
        />
      </div>
    ),
    beforeChange: (_current, next) => setActiveSlide(next),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
        }
      }
    ]
  };

  return (
    <div id="user-fidelity-card" className={isPWA ? 'pwa' : ''}>
      <FooterAccount
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />

      {!isLoading ? (
        <div className="user-fidelity-card-body">

          <div className="user-fidelity-card-content">
          <div className="vector-top-fidelity">
            <img src={VectorTopFidelity} alt="VectorTopFidelity" />
          </div>
          <div className='relative z-20'>
          {!isPWA && <BackButton onClick={() => navigate(ACCOUNT)} />}

          </div>
            <div className="user-fidelity-card-title">Mes cartes fidélité</div>

            <div className="carousel-container">
              {fidCards.length > 0 ? (
                <Slider {...sliderSettings} className="fidelity-cards-carousel">
                  {fidCards.map((fidCard, index) => (
                    <div key={index} className="carousel-slide relative">
                      <img src={pikkoLogo} alt="PikkoPay" className={`w-[100px] h-[100px] object-contain rounded-2xl absolute  duration-300 delay-700 transition-[cubic-bezier(0.68,-0.55,0.27,1.55)] -left-10 transform  ${
                        index === activeSlide ? ' -top-20 -rotate-12 left-0' : 'top-10 -rotate-0 left-20'
                      }`} />
                      <FidelityCardTile
                        onClick={() => onClickFidCard(fidCard)}
                        img={fidCard.cardImage}
                        logo={fidCard.companyImage}
                        name={fidCard?.fidelityInfo?.ficheClient?.nom}
                        surname={fidCard?.fidelityInfo?.ficheClient?.prenom}
                        numero={fidCard?.fidelityInfo?.ficheClient?.numeroCarte}
                      />
                    </div>
                  ))}
                  <div className="carousel-slide">
                    <div className="fidelity-card-tile" onClick={onClickAddFidCard}>
                      <div className="add-card-button">
                        <FaPlus className='w-16 h-16' color='#a6a3a3' />
                      </div>
                    </div>
                  </div>
                </Slider>
              ) : (
                <div className="empty-carousel">
                  <div className="fidelity-card-tile" onClick={onClickAddFidCard}>
                    <div className="add-card-button">
                      <FaPlus className='w-16 h-16' color='#a6a3a3' />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className='flex justify-center w-full mt-auto px-8'>
            <PrimaryButton
            label={'Ajouter une carte'}
            onClick={onClickAddFidCard}
            />
            </div>
          </div>

          {showAddFidCardSlider && (
            <AddFidCardSlider
              isOpen={showAddFidCardSlider}
              onClose={() => setShowAddFidCardSlider(false)}
            />
          )}
        </div>
      ) : (
        <PageLoader />
      )}
      <ScanFooter originPath={USER_FID_CARD} />
    </div>
  );
};

export default UserFidelityCard;
